<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <label class="header_text mb-3">
                {{$t('dashboardPage.templateRenewal')}}
            </label>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-md-12 pr-0">
            <div class="card card_layout">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.senderName')}}</label>
                                <input class="form-control" :disabled="true" v-model="senderName" type="text" />
                            </div>
                        </div>
                    </div>
                    <div v-if="isLoading" class="text-center py-4">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>
                    <div v-else-if="loadFailed || !candidates.length" class="text-center py-4">
                        {{$t('shared.noDataAvailable')}}
                    </div>
                    <template v-else>
                        <v-data-table :headers="headers" :items="candidates"
                                      :rows-per-page-text="$t('shared.rowsPerPage')" :rows-per-page-items="[10, 25, 50, 100]"
                                      item-key="requestId" class="elevation-1 table-striped">
                            <template v-slot:headers="props">
                                <tr>
                                    <th>
                                        <v-checkbox :input-value="allEligibleSelected"
                                                    :indeterminate="selected.length > 0 && !allEligibleSelected" primary hide-details
                                                    :disabled="isSelectionLocked || !candidates.length"
                                                    @change="toggleAll($event)"></v-checkbox>
                                    </th>
                                    <th v-for="header in props.headers" :key="header.text" class="text-center">
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                            <template v-slot:items="props">
                                <tr>
                                    <td>
                                        <v-checkbox :input-value="isSelected(props.item)" :disabled="!isRowSelectable(props.item)"
                                                    @change="toggleRow(props.item, $event)" primary hide-details></v-checkbox>
                                    </td>
                                    <td class="text-center">{{ props.item.templateName }}</td>
                                    <td class="text-center">{{ props.item.classification || '-' }}</td>
                                    <td class="text-center">{{ props.item.isVariableTemplate ? $t('shared.variable') : $t('shared.nonVariable') }}</td>
                                    <td class="text-center">{{ props.item.currentExpiryDate || '-' }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
                <div class="card-footer">
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto d-flex flex-wrap align-items-center">
                            <button type="button" class="btn btn-outline-primary px-5 py-2 mr-2 mb-2" @click="cancel">
                                {{$t('shared.cancel')}}
                            </button>
                            <button type="button" class="btn btn-outline-secondary px-4 py-2 mr-2 mb-2"
                                    :disabled="!isValidStep || isLoading || submitInFlight"
                                    @click="payLater">
                                {{$t('dashboardPage.payLater')}}
                            </button>
                            <button type="button" class="btn btn-danger px-5 py-2 mb-2"
                                    :disabled="!isValidStep || isLoading || submitInFlight"
                                    @click="payNow">
                                {{$t('dashboardPage.payNow')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
